import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@soleran/authentication';

import { SearchModuleService } from '@soleran/audit';
import {
  distinctUntilChanged,
  filter,
  interval,
  Subject,
  Subscription,
  switchMap,
} from 'rxjs';
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit {
  @Input()
  title: string = '';
  searchValueChanges$ = new Subject<string>();
  private _subs = new Subscription();
  constructor(
    private _auth: AuthenticationService,
    private _router: Router,
    private _sms: SearchModuleService,
    private _cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this._cd.detach();
    this._subs.add(
      interval(1000 / 30).subscribe(() => this._cd.detectChanges())
    );
  }

  onSignOutClick() {
    this._auth.logout();
    this._router.navigateByUrl('/login');
  }

  onBuildAndConfigureClick() {
    const prefix = ['dev', 'localhost'].some((x) =>
      window.location.host.toLowerCase().startsWith(x)
    )
      ? 'dev'
      : '';

    const _ = window.open(`https://${prefix}admin.soleran.net`, '_blank');
  }
  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
  private _searchModulesChange() {
    const changes = this.searchValueChanges$.asObservable();
    const validChanges = changes.pipe(
      filter((v) => !!v),
      distinctUntilChanged()
    );
    const results = validChanges.pipe(switchMap((v) => this._search(v)));
    return results;
  }
  private _search(searchText: string) {
    return this._sms.get({ searchText });
  }
}
